@if (filteredByAuthor$ | async; as author) {
  <div class="mt-3"
       i18n>
    Filtered by Author:
    <i>"{{ author }}"</i>&nbsp;
    <a href="#"
       (click)="clearFilterByAuthor($event)">Cancel</a>
  </div>
}
@if ((tableSettings$ | async); as tableSettings) {
  <p-table [scTableSettings]="tableSettings"
           class="mt-3">
  </p-table>
}